import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "upload-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "upload-empty"
};
const _hoisted_7 = {
  class: "el-upload__tip"
};
import { generateUUID } from '@/utils';
import { propTypes } from '@/utils/propTypes';
import { createImageViewer } from '@/components/ImageViewer';
import { useUpload } from '@/components/UploadFile/src/useUpload';
import { useMessage } from '@/hooks/web/useMessage';
import { ref } from 'vue';
// 接受父组件参数
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'UploadImg'
  },
  __name: 'UploadImg',
  props: {
    modelValue: propTypes.string.def(''),
    drag: propTypes.bool.def(true),
    // 是否支持拖拽上传 ==> 非必传（默认为 true）
    disabled: propTypes.bool.def(false),
    // 是否禁用上传组件 ==> 非必传（默认为 false）
    fileSize: propTypes.number.def(5),
    // 图片大小限制 ==> 非必传（默认为 5M）
    fileType: propTypes.array.def(['image/jpeg', 'image/png', 'image/gif']),
    // 图片类型限制 ==> 非必传（默认为 ["image/jpeg", "image/png", "image/gif"]）
    height: propTypes.string.def('150px'),
    // 组件高度 ==> 非必传（默认为 150px）
    width: propTypes.string.def('150px'),
    // 组件宽度 ==> 非必传（默认为 150px）
    borderradius: propTypes.string.def('8px'),
    // 组件边框圆角 ==> 非必传（默认为 8px）
    showDelete: propTypes.bool.def(true),
    // 是否显示删除按钮
    showBtnText: propTypes.bool.def(true) // 是否显示按钮文字
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    _useCssVars(_ctx => ({
      "203c8a1e": __props.width,
      "64f48062": __props.height,
      "054fa066": __props.borderradius
    }));
    const props = __props;
    const message = useMessage(); // 消息弹窗
    // 生成组件唯一id
    const uuid = ref('id-' + generateUUID());
    // 查看图片
    const imagePreview = imgUrl => {
      createImageViewer({
        zIndex: 9999999,
        urlList: [imgUrl]
      });
    };
    const emit = __emit;
    const deleteImg = () => {
      emit('update:modelValue', '');
    };
    const {
      uploadUrl,
      httpRequest
    } = useUpload();
    const editImg = () => {
      const dom = document.querySelector(`#${uuid.value} .el-upload__input`);
      dom && dom.dispatchEvent(new MouseEvent('click'));
    };
    const beforeUpload = rawFile => {
      const imgSize = rawFile.size / 1024 / 1024 < props.fileSize;
      const imgType = props.fileType;
      if (!imgType.includes(rawFile.type)) message.notifyWarning('上传图片不符合所需的格式！');
      if (!imgSize) message.notifyWarning(`上传图片大小不能超过 ${props.fileSize}M！`);
      return imgType.includes(rawFile.type) && imgSize;
    };
    // 图片上传成功提示
    const uploadSuccess = res => {
      message.success('上传成功');
      emit('update:modelValue', res.data);
    };
    // 图片上传错误提示
    const uploadError = () => {
      message.notifyError('图片上传失败，请您重新上传！');
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_upload, {
        id: uuid.value,
        accept: __props.fileType.join(','),
        action: _unref(uploadUrl),
        "before-upload": beforeUpload,
        class: _normalizeClass(['upload', __props.drag ? 'no-border' : '']),
        disabled: __props.disabled,
        drag: __props.drag,
        "http-request": _unref(httpRequest),
        multiple: false,
        "on-error": uploadError,
        "on-success": uploadSuccess,
        "show-file-list": false
      }, {
        default: _withCtx(() => [__props.modelValue ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("img", {
          src: __props.modelValue,
          class: "upload-image"
        }, null, 8, _hoisted_2), _createElementVNode("div", {
          class: "upload-handle",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [!__props.disabled ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "handle-icon",
          onClick: editImg
        }, [_createVNode(_component_Icon, {
          icon: "ep:edit"
        }), __props.showBtnText ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString('修改'))) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "handle-icon",
          onClick: _cache[0] || (_cache[0] = $event => imagePreview(__props.modelValue))
        }, [_createVNode(_component_Icon, {
          icon: "ep:zoom-in"
        }), __props.showBtnText ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString('详情'))) : _createCommentVNode("", true)]), __props.showDelete && !__props.disabled ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "handle-icon",
          onClick: deleteImg
        }, [_createVNode(_component_Icon, {
          icon: "ep:delete"
        }), __props.showBtnText ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString('删除'))) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, "empty", {}, () => [_createVNode(_component_Icon, {
          icon: "ep:plus"
        })])]))]),
        _: 3
      }, 8, ["id", "accept", "action", "class", "disabled", "drag", "http-request"]), _createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "tip")])]);
    };
  }
});